import {
  E
} from '@ppzp/utils.rc';

import {
  IconButton
} from '../iconfont/index.coffee';

import './index.styl';

export default function({state, className, children}) {
  if (state.value) {
    return E({
      plass: ['dialog_container', className],
      onClick: function(evt) {
        if (evt.currentTarget === evt.target) {
          return state.set(false);
        }
      },
      children: E({
        plass: 'dialog_wrapper',
        children: E._(E(IconButton, {
          className: 'dialog_btn_close',
          type: 'close',
          onClick: function() {
            return state.set(false);
          }
        }), children)
      })
    });
  }
};
